import { type ReactNode } from "react";

import { Box, CircularProgress, Typography } from "@mui/material";

interface WholePageSpinnerProps {
  message?: string | ReactNode;
}

const WholePageSpinner = (props: WholePageSpinnerProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        padding: 4,
        minHeight: ["calc(100vh - 3rem)", "calc(100vh - 3.5rem)"]
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          pt: 20,
          pb: 20
        }}
      >
        <CircularProgress size="4rem" />
        {props.message && (
          <Typography variant="h6" sx={{ mt: 2 }}>
            {props.message}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default WholePageSpinner;
